export {default} from './RegistrationForm';



// WEBPACK FOOTER //
// ./src/containers/RegistrationForm/index.ts